const SubHeroIcons = [
  {
    id: 1,
    img: require('~/assets/images/splash/sub-hero-industries.svg'),
    label: '20+ Industries',
  },
  {
    id: 2,
    img: require('~/assets/images/splash/sub-hero-states.svg'),
    label: 'All 50 states',
  },
  {
    id: 3,
    img: require('~/assets/images/splash/sub-hero-staff.svg'),
    label: 'Up to 500 Employees',
  },
  {
    id: 4,
    img: require('~/assets/images/splash/sub-hero-certified.svg'),
    label: 'HR Certified',
  },
];

export default SubHeroIcons;
